module.exports = __webpack_public_path__ + "static/media/referralOff_118.203b4c8f.png";